import React from 'react';
import BaseStaticPage from '../BaseStaticPage';
import { isEmptyList, merge } from '../../../utils';
import baseStaticStyles from '../BaseStaticPage/styles';
import { EVENT_ACTIONS, EVENT_CATEGORIES, logEvent } from '../../../services/Analytics';
import styles from './styles';
import { guc } from '../../../services/Localisation';
import { withResizer } from '../../../HoCs';
import ButtonBase from '@material-ui/core/ButtonBase';
import Timer from '../../../resources/vectors/Timer';
import HandShake from '../../../resources/vectors/HandShake';
import Friends from '../../../resources/vectors/Friends';
import Casino from '../../../resources/vectors/Casino';
import ReactHtmlParser from 'react-html-parser';

class Giveaway extends BaseStaticPage {
    
    styles = merge(baseStaticStyles, styles);
    content_json_key = 'win_a_trip_json';
    state = this.parseJsonString();
    footerLinks = [
        { content: guc('partner_page'), href: '/', event_action: EVENT_ACTIONS.HOME_PAGE_LINK_CLICKED },
        { content: guc('terms_and_conditions'), href: this.state.data.us_lv_tandc_link, target: '_blank', event_action: EVENT_ACTIONS.TNC_CLICKED }
    ];
    
    onGetStartedClicked = () => logEvent(EVENT_CATEGORIES.MYRTLE_BEACH_2021_PAGE, EVENT_ACTIONS.GET_STARTED_CLICKED);
    
    onRightCardTnClicked = () => logEvent(EVENT_CATEGORIES.MYRTLE_BEACH_2021_PAGE, EVENT_ACTIONS.HEADER_TNC_CLICKED);
    
    renderImage = () => {
        const { image, us_lv_lcard_title, us_lv_lcard_content, us_lv_rcard_title, us_lv_rcard_content, us_lv_survey_link, get_started, us_lv_rcard_foot_prefix, us_lv_tandc_link, t_amp_c, image_text_style } = this.state.data;
        return <div style={merge(this.gs('image_containter'), { backgroundImage: `url(${image})` })}>
            <div style={merge(this.gs('left_card'), image_text_style)}>
                <div style={this.gs('left_card_heading')}>{us_lv_lcard_title}</div>
                <div style={{ marginTop: 12 }}>{us_lv_lcard_content}</div>
            </div>
            <div style={this.gs('card_divider')} />
            <div style={merge(this.gs('right_card'), image_text_style)}>
                <div>{us_lv_rcard_title}</div>
                <div style={{ marginTop: 12 }}>{us_lv_rcard_content}</div>
                <a href={us_lv_survey_link} onClick={this.onGetStartedClicked} target='_blank'><ButtonBase style={this.gs('start_button')}>{get_started}</ButtonBase></a>
                <div style={this.gs('tandc_text_in_card')}>{us_lv_rcard_foot_prefix} <a href={us_lv_tandc_link} onClick={this.onRightCardTnClicked} target='_blank' style={this.gs('tandc_link_in_card')}>{t_amp_c}</a></div>
            </div>
        </div>;
    }
    
    renderStep = (number, Icon, content) => <div style={this.gs('step')}>
        <Icon {...this.gs('step_icon')} />
        <div style={this.gs('step_number')}>Step {number}</div>
        <div style={this.gs('step_content')}>{content}</div>
    </div>;
    
    onEnterToWinClicked = () => logEvent(EVENT_CATEGORIES.MYRTLE_BEACH_2021_PAGE, EVENT_ACTIONS.ENTER_TO_WIN_CLICKED);
    
    renderSteps = () => {
        const { us_lv_heres_how, us_lv_step1_content, us_lv_step2_content, us_lv_step3_content, us_lv_step4_content, enter_to_win, us_lv_survey_link } = this.state.data;
        return <div style={this.gs('steps_container')}>
            <div style={this.gs('you_can_enter')}>{us_lv_heres_how}</div>
            <div style={this.gs('steps')}>
                {this.renderStep(1, Timer, us_lv_step1_content)}
                {this.renderStep(2, HandShake, us_lv_step2_content)}
                {this.renderStep(3, Friends, us_lv_step3_content)}
                {this.renderStep(4, Casino, us_lv_step4_content)}
            </div>
            <a href={us_lv_survey_link} target='_blank' onClick={this.onEnterToWinClicked}><ButtonBase style={this.gs('start_button')}>{enter_to_win}!</ButtonBase></a>
        </div>;
    }
    
    onTncClicked = () => logEvent(EVENT_CATEGORIES.MYRTLE_BEACH_2021_PAGE, EVENT_ACTIONS.TNC_SECTION_CLICKED);
    
    renderTermsAndconditions = () => {
        const { us_lv_tandc_list, terms_and_conditions, Click, here, for_detailed_terms_and_conditions, us_lv_tandc_link } = this.state.data;
        let tandcs = [];
        return <div style={this.gs('tandc_container')}>
            <div style={this.gs('tandc_title')}>{terms_and_conditions}</div>
            <ol style={this.gs('tandc_ol')}>
                {!isEmptyList(us_lv_tandc_list) && us_lv_tandc_list.map((tandc, i) => <li key={i} style={this.gs('tandc')}>{ReactHtmlParser(tandc)}</li>)}
                <div style={this.gs('tandc_text_in_card')}>{Click} <a href={us_lv_tandc_link} onClick={this.onTncClicked} target='_blank' style={this.gs('tandc_link_in_card')}>{here}</a> {for_detailed_terms_and_conditions}.</div>
            </ol>
        </div>;
    }
    
    renderContent = () =>
        <>
            {this.renderSteps()}
            {this.renderTermsAndconditions()}
        </>;
    
    
}

export default withResizer(Giveaway);